import { fetchApi } from "./fetchApi";

export async function onChange(raw, model) {
  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };

  return fetchApi({
    requestOptions,
    endpoint: `/web/dataset/call_kw/${model}/onchange`,
  });
}
